export interface IPOApplication {
  id: string;
  type: string;
  ipoName: string;
  applicationNo?: string;
  applicationId?: string;
  exchangeRef?: string;
  dpId: string;
  qty: number;
  amount: number;
  status: "pending" | "allotted" | "unallocated" | "refunded";
  appliedDate?: string;
}

export const userIPOApplications: IPOApplication[] = [
  {
    id: "1",
    type: "Main Board",
    ipoName: "TechCorp Solutions Limited",
    applicationNo: "APP001234567",
    exchangeRef: "NSE123456",
    dpId: "DP123456789",
    qty: 120,
    amount: 15000,
    status: "pending",
  },
  {
    id: "2",
    type: "Main Board",
    ipoName: "GreenEnergy Power Limited",
    applicationNo: "APP001234568",
    exchangeRef: "BSE789012",
    dpId: "DP123456789",
    qty: 200,
    amount: 18000,
    status: "pending",
  },
  {
    id: "3",
    type: "SME",
    ipoName: "FinTech Innovations Private Limited",
    applicationId: "APP001234569",
    dpId: "DP123456789",
    qty: 300,
    amount: 15000,
    status: "allotted",
    appliedDate: "2024-01-15",
  },
  {
    id: "4",
    type: "Main Board",
    ipoName: "MediCare Pharmaceuticals Limited",
    applicationId: "APP001234570",
    dpId: "DP123456789",
    qty: 60,
    amount: 15600,
    status: "unallocated",
    appliedDate: "2024-02-10",
  },
  {
    id: "5",
    type: "SME",
    ipoName: "AgriGrow Limited",
    applicationId: "APP001234571",
    dpId: "DP123456789",
    qty: 400,
    amount: 14000,
    status: "refunded",
    appliedDate: "2024-01-20",
  },
  {
    id: "6",
    type: "Main Board",
    ipoName: "RetailMart Limited",
    applicationId: "APP001234572",
    dpId: "DP123456789",
    qty: 100,
    amount: 19000,
    status: "allotted",
    appliedDate: "2024-02-05",
  },
];
